import clsx from "clsx";
import { useTranslation } from "react-i18next";
import { AI_MODEL_AUTO } from "../../api/aiApi";
import type { AiSurface } from "../../store/aiModel.store";
import { Select } from "../forms/Select";
import { useAiModel, useAiModelChoices } from "./useAiModel";

/**
 * Chooses the model an AI action runs on, shown beside that action. Hidden
 * when there is nothing to choose (no provider, or only "auto").
 */
export function AiModelPicker({
  surface,
  disabled,
  className,
  triggerClassName = "h-9 py-0 text-sm",
}: {
  surface: AiSurface;
  disabled?: boolean;
  className?: string;
  triggerClassName?: string;
}) {
  const { t } = useTranslation("ai");
  const choices = useAiModelChoices();
  const [model, setModel] = useAiModel(surface);
  if (choices.length <= 1) return null;

  return (
    <div title={t("model.hint", { defaultValue: "The AI model this runs on. Auto picks the right model for the task." })}>
      <Select
        className={clsx("!w-44 shrink-0", className)}
        triggerClassName={triggerClassName}
        searchable={false}
        disabled={disabled}
        value={model}
        onChange={setModel}
        name={`ai-model-${surface}`}
        options={choices.map((c) => ({
          value: c.id,
          label:
            c.id === AI_MODEL_AUTO
              ? t("model.auto", { defaultValue: "Model: Auto" })
              : c.label,
        }))}
      />
    </div>
  );
}
